import { inject } from '@angular/core';

import { Logger, WINDOW } from '@frontend/vanilla/core';

import { VIEW_TRANSITION_LOG_TAG as LOG_TAG, NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE } from '../../view-transition.constants';
import { NativeTransitionDetectionStrategy } from './model/native-transition-detection.strategy.model';

export class NavigationApiNativeTransitionDetectionStrategy implements NativeTransitionDetectionStrategy {
    readonly #logger = inject(Logger);
    readonly #navigation = inject(WINDOW).navigation;

    #navigationHasNativeTransition = false;

    get navigationHasNativeTransition(): boolean {
        return this.#navigationHasNativeTransition;
    }

    init(): this {
        this.listenForNativeTransitions();

        return this;
    }

    private listenForNativeTransitions(): void {
        this.#navigation.addEventListener('navigate', (event: NavigateEvent) => {
            if (event.hasUAVisualTransition) {
                this.#logger.info(`${LOG_TAG} ${NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE}`);
            }

            this.#navigationHasNativeTransition = event.hasUAVisualTransition;
        });
    }
}
